import { useEffect } from 'react';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment-timezone';

import Wrapper from 'components/layouts/Wrapper/Wrapper';
import {
  BalanceStatsBar,
  LoadingSpinner,
  ToolBar,
  Typhography,
  SelectBox,
  Headers,
  AccordionItem,
  // Pagination,
} from 'components/core';
import ListEmpty from 'components/modules/Common/ListEmpty/ListEmpty';

import { balanceDaysTabnavData } from 'constants/TabNavData';
import { CONFIG } from 'shared/configs/config';

import { getURLParams, useDateRangeSorting } from 'hooks/useDateRangeSorting';
import { useCurrencyFormat } from 'hooks/useCurrencyFormat';

import { handleBalanceAccordionClick } from 'helpers/modules/helperBalance';

import {
  useGetPastBalanceHeroStatsQuery,
  useGetPendingBalanceApiQuery,
} from 'services/pastBalanceApi';

const PastContainer = () => {
  const [
    rangeSelector,
    defaultSortingText,
    itemSlectedState,
    showDropdown,
    handlerSortingDropDownClick,
    handlerSortingOption,
  ]: any = useDateRangeSorting('All');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    navigate(
      {
        pathname: location.pathname,
        search: `?${createSearchParams(getURLParams(defaultSortingText))}`,
      },
      { replace: true }
    );
  }, [defaultSortingText]);

  const setLessThanDate = moment()
    .tz('America/Chicago')
    .add(0, 'day')
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    .format();
  const setGreaterThan =
    rangeSelector > 0
      ? moment()
          .tz('America/Chicago')
          .subtract(rangeSelector, 'day')
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .format()
      : undefined;

  /*
   * List the Past Invoices
   */
  const pastInvoicesParams = {
    first: CONFIG.DATA_OVERALL_LIMIT,
    offset: 0,
    filter: {
      status: { in: ['INVOICED', 'APPROVED', 'PAID'] },
      customer_payment_due_at: {
        lessThan: setLessThanDate,
        greaterThan: setGreaterThan,
      },
    },
    groupBy: 'CUSTOMER_PAYMENT_DUE_AT_TRUNCATED_TO_DAY_CST',
    orderGroupBy: 'DESC',
  };

  const { data, isLoading, isFetching }: any = useGetPendingBalanceApiQuery(pastInvoicesParams);

  /*
   * Fetch the Past Invoices Hero Stats data
   */
  const pastHeroStatsParams = {
    filter: {
      status: { in: ['APPROVED', 'PAID', 'INVOICED'] },
      customer_payment_due_at: {
        lessThan: setLessThanDate,
        greaterThan: setGreaterThan,
      },
    },
    timeCycleDays: '' + rangeSelector + '',
  };

  const { data: pastBalanceStatsBarData, isSuccess: isSuccessPastBalanceStatsBar }: any =
    useGetPastBalanceHeroStatsQuery(pastHeroStatsParams);

  return (
    <>
      {(isLoading || isFetching) && <LoadingSpinner />}
      <Wrapper additionalClasses="flex-col items-start" pageTitle="Balance">
        <Headers headingContent="Balance" />
        {!isLoading && (
          <>
            <ToolBar navigationData={balanceDaysTabnavData} isShowOptionEnabled={false}>
              <SelectBox
                itemClickHandler={handlerSortingOption}
                defaultSelectBoxText={defaultSortingText}
                itemSelected={itemSlectedState}
                dropDownState={showDropdown}
                dropDownClickHandler={handlerSortingDropDownClick}
              />
            </ToolBar>

            {isSuccessPastBalanceStatsBar && (
              <BalanceStatsBar
                defaultSortingText={defaultSortingText}
                data={pastBalanceStatsBarData}
                timeFrame="past"
              />
            )}

            {data?.payouts?.groupedAggregates.length > 0 && (
              <div className="flex flex-col w-full">
                <Typhography
                  component="div"
                  type="h2"
                  color="text-grey-900"
                  additionalClasses="items-center uppercase pt-9 pb-3 border-t border-solid border-grey-100 px-4 !font-normal"
                >
                  {'Invoices List'}
                </Typhography>
                <div className="flex flex-col w-full invoices-list-wrapper">
                  {data?.payouts?.groupedAggregates.map((listItem: any) => {
                    const convertedPrice = parseFloat(listItem?.sum?.amount);

                    return (
                      <div className="flex flex-col w-full mb-0" key={listItem.keys[0]}>
                        <AccordionItem
                          mainLabel="Invoice"
                          subLabel={moment(listItem.keys[0])
                            .tz('America/Chicago')
                            .format('MM/DD/YYYY')}
                          rightColContent={useCurrencyFormat(convertedPrice)}
                          isInvoiceTag={false}
                          clickAccordion={() =>
                            handleBalanceAccordionClick(listItem.keys[0], navigate)
                          }
                          isLink={false}
                          isRemoveTopBorder={data?.payouts?.groupedAggregates.length === 1}
                        />
                      </div>
                    );
                  })}
                </div>
                {/* <Pagination
                  options={[25, 50, 75, 100, 125, 150, 200]}
                  totalPageCount={10}
                  canNextPage={true}
                  canPreviousPage={true}
                  pageIndex={0}
                /> */}
              </div>
            )}
            {data?.payouts?.groupedAggregates.length === 0 && <ListEmpty />}
          </>
        )}
      </Wrapper>
    </>
  );
};

export default PastContainer;
